export const onlyOnlineRoutes = [
  "search",
  "reports/add-report",
  "summary/reviews",
  "summary/audits",
  "organize-logbooks",
  "settings/userlist",
  "settings/NMEA",
  "settings/logman",
];
